<template>
    <div class="modalBg d-flex flex-column align-items-center justify-content-center" @click.self="closeModal">
        <div class="modalContent p-3">

            <!-- Title -->
            <h3 class="text-center">Create Invoice</h3>

            <div v-if="getIsDownloadingInvoiceResume" class="d-flex w-100 justify-content-center my-4">
                <loader></loader>
            </div>

            <!-- Invoice To Selctor -->
            <div v-else class="mt-2 d-flex">
                <button @click="setInvoiceTo('customer')" :class="{'blue': invoiceTo == 'customer'}" class="btn tertiary full super mr-3">Customer</button>
                <button @click="setInvoiceTo('agent')" :disabled="!enableAgentBtn" :class="{'blue': invoiceTo == 'agent'}" class="btn tertiary full super">Agent</button>
            </div>

            <!-- Value to invoice & Agent Picker -->
            <div class="mt-2 d-flex justify-content-between">
                <div>
                    <seller-picker
                        v-if="invoiceTo == 'agent'"
                        :reservation="reservation"
                        :changeReservationSeller="false"
                        :showMyTeam="false"
                        :inlcudeWidget="false"
                        :orignalSeller="reservation.creatorAgent"
                        :disabled="getIsCreatingInvoice"
                        @input="sellerChanged">
                    </seller-picker>
                </div>
                <div v-if="invoiceTo">
                    <label :class="{'color-6':invalidInvoiceValue}">
                        Amount to invoice
                    </label>
                    <div v-if="getIsDownloadingInvoiceResume">
                        <loader></loader>
                    </div>
                    <div v-else class="fs-larger text-right darker bold" :class="{'color-6':invalidInvoiceValue}" >{{formatPrice(valueToInvoice)}}€</div>
                </div>
            </div>

            <!-- Billing Info Form -->
            <div v-if="invoiceTo" class="row mt-2">

                <div class="col-sm-4" :class="{ error: $v.invoiceToForm.vat.$invalid }">
                    <div class="d-flex justify-content-between">
                        <label>
                            VAT Number <span class="color-6" v-if="isInvoiceValueOver">*</span>
                        </label>
                        <div v-if="$v.invoiceToForm.vat.$invalid" class="messages fs-smaller">
                            <span v-if="!$v.invoiceToForm.vat.required">Required.</span>
                        </div>
                    </div>
                    <input type="text" class="full" v-model="invoiceToForm.vat" :disabled="getIsCreatingInvoice" @input="$v.invoiceToForm.vat.$touch">


                </div>

                <div class="col-sm-4" :class="{ error: $v.invoiceToForm.city.$invalid }">
                    <div class="d-flex justify-content-between">
                        <label>
                            City <span v-if="isInvoiceValueOver" class="color-6">*</span>
                        </label>
                        <div v-if="$v.invoiceToForm.city.$invalid" class="messages fs-smaller">
                            <span v-if="!$v.invoiceToForm.city.required">Required.</span>
                        </div>
                    </div>
                    <input type="text" class="full" v-model="invoiceToForm.city" :disabled="getIsCreatingInvoice">
                </div>

                <div class="col-sm-4" :class="{ errorSelect: $v.invoiceToForm.country.$invalid }">
                    <div class="d-flex justify-content-between">
                        <label>
                            Country <span v-if="isInvoiceValueOver" class="color-6">*</span>
                        </label>
                        <div v-if="$v.invoiceToForm.country.$invalid" class="messages fs-smaller error">
                            <span v-if="!$v.invoiceToForm.country.required">Required.</span>
                        </div>
                    </div>
                    <v-select :options="getCountries" v-model="selectedCountry" :disabled="getIsCreatingInvoice" placeholder="Select Country" label="name" @input="selectedCountryChanged"></v-select>
                </div>

                <div class="col-sm-6 mt-3" :class="{ error: $v.invoiceToForm.businessName.$invalid }">
                    <div class="d-flex justify-content-between">
                        <label>
                            Billing Name <span v-if="isInvoiceValueOver" class="color-6">*</span>
                        </label>
                        <div v-if="$v.invoiceToForm.businessName.$invalid" class="messages fs-smaller">
                            <span v-if="!$v.invoiceToForm.businessName.required">Required.</span>
                        </div>
                    </div>
                    <input type="text" class="full" v-model="invoiceToForm.businessName" :disabled="getIsCreatingInvoice">
                </div>

                <div class="col-sm-6 mt-3" :class="{ error: $v.invoiceToForm.address.$invalid }">
                    <div class="d-flex justify-content-between">
                        <label>
                            Address <span v-if="isInvoiceValueOver" class="color-6">*</span>
                        </label>
                        <div v-if="$v.invoiceToForm.address.$invalid" class="messages fs-smaller">
                            <span v-if="!$v.invoiceToForm.address.required">Required.</span>
                        </div>
                    </div>
                    <input type="text" class="full" v-model="invoiceToForm.address" :disabled="getIsCreatingInvoice">
                </div>

            </div>

            <!-- Buttons -->
            <div v-if="invoiceTo" class="mt-4 text-right d-flex w-100 justify-content-between align-items-center">
                <div class="">
                    <span v-if="getIsCreatingInvoice" class="dark">Take a fresh breath while we create your Invoice 🌴 </span>
                </div>
                <div class="text-right">
                    <button class="btn tertiary" :disabled="getIsCreatingInvoice" @click="closeModal">Cancel</button>
                    <button class="btn blue ml-2" :disabled="invalidInvoiceValue || getIsCreatingInvoice || $v.$invalid" @click="createInvoice()">{{getIsCreatingInvoice? 'Invoicing' :'Invoice'}}</button>
                    <button class="btn blue ml-2" :disabled="invalidInvoiceValue || getIsCreatingInvoice || $v.$invalid" @click="createInvoice({bill: true})" v-if="invoiceTo != 'agent'">{{getIsCreatingInvoice? 'Invoicing' :'Invoice/Receipt'}}</button>
                </div>
            </div>
        </div>


        </div>
    </div>
</template>

<script>
import extendedVSelect from '@/extends/vue-select'
import { mapGetters, mapActions } from 'vuex'
import SellerPicker from '@/tools/SellerPicker'
import Loader from '@/tools/loaders/loader1'
import { required, email, minLength, requiredIf } from 'vuelidate/lib/validators'

export default {
    data: function () {
        return {
            invoiceTo: null,
            selectedCountry: null,
            selectedAgent: null,
            invoiceToForm: {
                vat: null,
                city: null,
                country: null,
                businessName: null,
                address: null
            },
            invoiceResume: null
        }
    },
    computed: {
        ...mapGetters([
            'getCountries',
            'getAgents',
            'getIsDownloadingInvoiceResume',
            'getIsCreatingInvoice',
            'getValueToAskMoreBillingInfo',
            'account'
        ]),
        enableAgentBtn: function () {
            return this.reservation.creatorAgent
        },
        valueToInvoice: function () {
            if(this.getIsDownloadingInvoiceResume || !this.invoiceResume){
                return false
            }

            if(this.invoiceTo == 'customer'){
                return this.invoiceResume.invoiceRequestCustomer.total
            } else if (this.invoiceTo == 'agent') {
                return this.invoiceResume.invoiceRequestAgent.total
            }
        },
        isInvoiceValueOver: function () {
            return this.valueToInvoice > this.getValueToAskMoreBillingInfo
        },
        invalidInvoiceValue: function() {
            return this.valueToInvoice <= 0
        }
    },
    validations:{
        invoiceToForm: {
            vat: {
                required: requiredIf(function () { return this.isInvoiceValueOver })
            },
            city: {
                required: requiredIf(function () { return this.isInvoiceValueOver })
            },
            country: {
                required: requiredIf(function () { return this.isInvoiceValueOver })
            },
            businessName: {
                required: requiredIf(function () { return this.isInvoiceValueOver })
            },
            address: {
                required: requiredIf(function () { return this.isInvoiceValueOver })
            }
        },
    },
    props: {
        reservation: {
            type: Object
        }
    },
    created: function () {
        this.selectedAgent = this.getAgents[0]

        // download invoice value
        this.downloadReservationInvoiceResume(this.reservation.id).then(response => {
            console.log('downloadReservationInvoiceResume', response);
            if(response.serverInfo.type > 1){
                this.closeModal()
            } else {
                this.invoiceResume = response.data
            }
        }).catch(error => {
            console.log('error', error);
        })
    },
    methods:{
        ...mapActions([
            'downloadReservationInvoiceResume',
            'emitInvoice',
            'updateExistingReservation'
        ]),
        closeModal: function () {
            this.$emit('toggleInvoiceModal')
        },
        setInvoiceTo: function (newInvoiceTo) {
            this.invoiceTo = newInvoiceTo

            if(newInvoiceTo == 'customer'){
                this.fillFormWithCustomer()
            } else if (newInvoiceTo == 'agent') {
                // this.fillFormWithAgent(this.selectedAgent)
                this.fillFormWithAgent(this.reservation.creatorAgent)
                console.log('this.selectedAgent', this.reservation.creatorAgent);
            }
        },
        fillFormWithCustomer: function () {
            if(this.reservation.billing.details){
                this.invoiceToForm = this.reservation.billing.details
                this.setCountry()
            }
        },
        fillFormWithAgent: function (agentIn) {
            console.log('fn fillFormWithAgent', agentIn);
            let agent = agentIn ? agentIn : this.getAgents[0]
            this.invoiceToForm = {
                id: agent.id,
                vat: agent.vat? agent.vat : agent.taxpayerNumber,
                city: agent.location,
                country: agent.country? agent.country.id : null,
                businessName: agent.billingName? agent.billingName : agent.name,
                address: agent.address
            }
            this.setCountry()
        },
        createInvoice: function (options) {
            let vm = this

            if(!options){
                options = {
                    bill: false
                }
            }

            let invoiceTarget
            if(this.invoiceTo == 'customer'){
                //is costumer
                invoiceTarget = 0;
            } else {
                if(this.reservation.creatorAgent){
                    // is agent
                    invoiceTarget = 1;
                } else if( this.reservation.channelType) {
                    // is ota
                    invoiceTarget = 2;
                }
            }

            this.emitInvoice({
                reservationId: this.reservation.id,
                invoiceTargetType: invoiceTarget,
                isToInvoiceAndBill: options.bill? options.bill : false,
                client: this.invoiceToForm
            }).then(response => {

                if(response.status == 200){
                    this.reservation.bookingInvoices.push(response.data)
                    this.$toasted.success('Invoice created');

                    //save reservation
                     vm.updateExistingReservation({
                        supplierId: vm.account.supplierId,
                        reservation: vm.reservation
                    }).then(response => {
                        if(response.status && response.status == 200){
                            vm.reservation.updateFlags = {}
                        }
                    })
                    this.closeModal()
                }


            }).catch(err => {

            })
        },
        // ------------  Helper  ------------
        selectedCountryChanged: function (e) {
            if(e){
                this.invoiceToForm.country = e.id
            } else {
                this.invoiceToForm.country = null
            }
        },
        sellerChanged: function (newSeller) {
            this.selectedAgent = newSeller
            this.fillFormWithAgent(newSeller)
        },
        setCountry: function (countryId) {

            if(!countryId && this.invoiceToForm.country){
                countryId = this.invoiceToForm.country
            }

            if(typeof countryId == "object"){
                countryId = countryId.id
            }

            if(countryId === undefined){
                this.selectedCountry = null
                return false
            }
            this.selectedCountry = this.getCountries.filter(country => {
                return country.id == countryId
            })[0]
        },
        // ----------- modal stuff ----------
        closeModal: function () {
            this.$emit('close')
        }
    },
    components: {
        vSelect: extendedVSelect,
        SellerPicker,
        Loader
    }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_variables.scss';

.modalBg{
    z-index: 10;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);

    .modalContent{
        width: 800px;
        background-color: #FFF;
    }
}

</style>



// WEBPACK FOOTER //
// CreateInvoice.vue?c88d3d92